import styled from 'styled-components';

export const LastRowWrapper = styled.div`
  display: flex;
  flex-direction: row;
  margin: 0px 0px 30px 0px;
  justify-content: flex-end; 
  font-size: 1.2em;
  ${props => props.theme.mediaQueries.phone}{
    align-self: center;
    justify-content: center;
  }

`;

export const LiveLink = styled.div`
  margin-left: 0.5em;
  cursor: pointer;
`;

export const CompetitionData = styled.div`
  margin-left: 0.5em;
  cursor: pointer;
`;




// WEBPACK FOOTER //
// ./src/components/shared/LastRow/styles.js